import {detail, list} from "@mc/mc-legacy";
import * as localStorageUtils from "../utils/localStorageUtils";
import ObjednavkaApi from "../api/gen/cgo/ObjednavkaApi";
import SubjektApi from "../api/gen/cgo/SubjektApi";
import CiselnikApi from "../api/gen/cgo/CiselnikApi";
import ObjednavkaIdsVO from "../api/gen/cgo/ObjednavkaIdsVO";
import * as EnumVyznam from "../api/gen/cgo/EnumVyznam";
import * as EnumStavObjednavka from "../api/gen/cgo/EnumStavObjednavka";
import {toastr} from "react-redux-toastr";
import {formatDate} from "../utils/utils";
import {CAS_ROZPRACOVANI_KEY} from "../const/const";
import ObjednavkaFilterReqVO from "../api/gen/cgo/ObjednavkaFilterReqVO";

export const OBJEDNAVKA_DETAIL_AREA = "objednavkaDetail";
export const OBJEDNAVKA_RIGHTS_AREA = "objednavkaRights";
export const OBJEDNAVKA_UZIVATEL_AREA = "objednavkaUzivatel";
export const OBJEDNAVKA_UZIVATEL_ADRESY_AREA = "objednavkaUzivatelAdresyList";
export const OBJEDNAVKA_UZIVATEL_KARTY_AREA = "objednavkaUzivatelKartyList";
export const OBJEDNAVKA_UZIVATEL_POBOCKY_AREA = "objednavkaUzivatelPobockyList";
export const OBJEDNAVKA_UZIVATEL_VYCHOZI_HODNOTY_AREA = "objednavkaUzivatelVychoziHodnotyDetail";
export const OBJEDNAVKA_SPOLECNOST_AREA = "objednavkaSpolecnost";
export const OBJEDNAVKA_SPOLECNOST_ADRESY_AREA = "objednavkaSpolecnostAdresyList";
export const OBJEDNAVKA_SPOLECNOST_KARTY_AREA = "objednavkaSpolecnostKartyList";
export const OBJEDNAVKA_SPOLECNOST_NAKLSTRED_AREA = "objednavkaSpolecnostNakladovaStrediskaList";
export const OBJEDNAVKA_SPOLECNOST_PREDVOLBY_AREA = "objednavkaSpolecnostPredvolby";
export const OBJEDNAVKA_SEZNAM_SMJ_AREA = "objednavkaSeznamSmjList";
export const OBJEDNAVKA_KOD_UKON_LIST_AREA = "objednavkaKodUkonList";
export const OBJEDNAVKY_SHARED_AREA = "objednavky";
export const OBJEDNAVKY_LIST_AREA = `${OBJEDNAVKY_SHARED_AREA}.objednavkyList`;
export const OBJEDNAVKY_PREHLED_LIST_AREA = `${OBJEDNAVKY_SHARED_AREA}.objednavkyPrehledList`;
export const OBJEDNAVKY_LIST_COUNT_STATS_AREA = `${OBJEDNAVKY_SHARED_AREA}.objednavkyListCountStats`;
export const OBJEDNAVKA_SHARED_AREA = "objednavka";
export const ZAKAZKA_DETAIL_AREA = `${OBJEDNAVKA_SHARED_AREA}.zakazka`;
export const ZAKAZNIK_DETAIL_AREA = `${OBJEDNAVKA_SHARED_AREA}.zakaznik`;
export const DOPRAVA_DETAIL_AREA = `${OBJEDNAVKA_SHARED_AREA}.doprava`;
export const PLATBA_DETAIL_AREA = `${OBJEDNAVKA_SHARED_AREA}.platba`;
export const LAST_SAVED_STEP_AREA = "objednavkaLastStep";
export const LAST_SAVED_FINISHED_STEP_AREA = "objednavkaLastSavedFinishedStep";
export const CAS_ROZPRACOVANI_DETAIL_AREA = `objednavkaCasRozpracovani`;

export const FILTR_VSE = 'VSE';
export const FILTR_ZPRACOVAVANE = 'ZPRACOVAVANE';

const getAllIds = (parent, filter) => {
    console.log("Stavy", filter.stav);
    const fulltext = filter.fulltext && filter.fulltext.length > 0 ? filter.fulltext : null;
    let stavList = [filter.stav];
    if (filter.stav === FILTR_VSE) {
        stavList = null;
    } else if (filter.stav === FILTR_ZPRACOVAVANE) {
        stavList = EnumStavObjednavka.values.filter(stav =>
            stav !== EnumStavObjednavka.VYRIZ
            && stav !== EnumStavObjednavka.EXP
            && stav !== EnumStavObjednavka.STORN
        );
        console.log("Stavy2", stavList);
    }
    const datumOd = filter.datumOd ? formatDate(filter.datumOd, null, "YYYY-MM-DD") : null;
    const datumDo = filter.datumDo ? formatDate(filter.datumDo, null, "YYYY-MM-DD") : null;
    const filterReqVO: ObjednavkaFilterReqVO = {
        uzivatelId: filter.uzivatel ? filter.uzivatel.id : null,
        uzivatelIdVyrizuje: filter.uzivatelVyrizujeId,
        spolecnostId: parent,
        stavList: stavList,
        pobockaIdList: filter.pobockaIdList,
        datumOd: datumOd,
        datumDo: datumDo,
        stredisko: filter.nakladoveStredisko,
        findText: fulltext,
    }

    return ObjednavkaApi.getObjednavkaIds(filterReqVO);
};

const getRowsByIds = ids => {
    const idsVO: ObjednavkaIdsVO = {
        ids : ids,
    };
    return ObjednavkaApi.getObjednavkyPrehledByIds(idsVO);
};

/**
 * Načtení seznamu objednávek.
 * @param idSpolecnost ID společnosti za kterou filtrovat objednávky
 * @param forceFetch pokud je true, provede se vždy nové načtení
 * @return {function(*, *)}
 */
export function fetchObjednavkyIfNeeded(idSpolecnost, forceFetch = false) {
    return (dispatch) => {
        dispatch(list.InfiniteListActions.fetchIfNeeded(OBJEDNAVKY_LIST_AREA, idSpolecnost, getAllIds, getRowsByIds, forceFetch));
    }
}

/**
 * Přenačtení seznamu objednávek.
 * @param idSpolecnost ID společnosti za kterou filtrovat objednávky
 * @return {function(*, *)}
 */
export function reloadObjednavky(idSpolecnost) {
    return (dispatch) => {
        dispatch(list.InfiniteListActions.reload(OBJEDNAVKY_LIST_AREA, idSpolecnost, getAllIds, getRowsByIds));
    }
}

/**
 * Donačtení dalších objenávek.
 * @return {function(*, *)}
 */
export function loadObjednavkyMore() {
    return (dispatch) => {
        dispatch(list.InfiniteListActions.loadMore(OBJEDNAVKY_LIST_AREA, getRowsByIds));
    }
}

/**
 * Filtrování objednávek na základě filtru.
 * @param filter filter
 * @return {function(*, *)}
 */
export function filterObjednavky(filter) {
    return (dispatch) => {
        dispatch(list.InfiniteListActions.filter(OBJEDNAVKY_LIST_AREA, filter));
    }
}

/**
 * Zneplatnění seznamu objednávek.
 * @returns {Function}
 */
export function invalidateObjednavky() {
    return (dispatch) => {
        dispatch(list.InfiniteListActions.invalidate(OBJEDNAVKY_LIST_AREA));
    }
}

/**
 * Načtení statistik počtu objednávek dle stavu.
 * @returns {Function}
 */
export function fetchObjednavkyCountStatsIfNeeded() {
    return (dispatch) => {
        dispatch(detail.DetailActions.fetchIfNeeded(OBJEDNAVKY_LIST_COUNT_STATS_AREA, "", (parent, filter) => {
            const fulltext = filter.fulltext && filter.fulltext.length > 0 ? filter.fulltext : null;
            let stavList = [filter.stav];
            if (filter.stav === FILTR_VSE) {
                stavList = null;
            } else if (filter.stav === FILTR_ZPRACOVAVANE) {
                stavList = EnumStavObjednavka.values.filter(stav =>
                    stav !== EnumStavObjednavka.VYRIZ
                    && stav !== EnumStavObjednavka.EXP
                    && stav !== EnumStavObjednavka.STORN
                );
            }
            const spolecnostId = filter.spolecnostId ? filter.spolecnostId : null;
            const datumOd = filter.datumOd ? formatDate(filter.datumOd, null, "YYYY-MM-DD") : null;
            const datumDo = filter.datumDo ? formatDate(filter.datumDo, null, "YYYY-MM-DD") : null;
            const filterReqVO: ObjednavkaFilterReqVO = {
                uzivatelId: filter.uzivatel ? filter.uzivatel.id : null,
                uzivatelIdVyrizuje: filter.uzivatelVyrizujeId,
                spolecnostId: spolecnostId,
                stavList: stavList,
                pobockaIdList: filter.pobockaIdList,
                datumOd: datumOd,
                datumDo: datumDo,
                stredisko: filter.nakladoveStredisko,
                findText: fulltext,
            }
            return ObjednavkaApi.getObjednavkaStavCount(filterReqVO);
        }));
    }
}

/**
 * Filtrování statistik počtu objednávek.
 * @param filter filtr
 * @returns {Function}
 */
export function filterObjednavkyCountStats(filter) {
    return (dispatch) => {
        dispatch(detail.DetailActions.filter(OBJEDNAVKY_LIST_COUNT_STATS_AREA, filter));
    }
}

/**
 * Zneplatnění statistik počtů objednávek dle stavu.
 * @returns {Function}
 */
export function invalidateObjednavkyCountStats() {
    return (dispatch) => {
        dispatch(detail.DetailActions.invalidate(OBJEDNAVKY_LIST_COUNT_STATS_AREA, ""));
    }
}

/**
 * Načtení detailu objednávky.
 * @returns {Function}
 */
export function fetchObjednavkaIfNeeded(id) {
    return (dispatch) => {
        dispatch(detail.DetailActions.fetchIfNeeded(OBJEDNAVKA_DETAIL_AREA, id, (parent) => {
            return ObjednavkaApi.getObjednavka(parent);
        }));
    }
}

/**
 * Zneplatnění detailu objednávky.
 * @returns {Function}
 */
export function invalidateObjednavka(id) {
    return (dispatch) => {
        dispatch(detail.DetailActions.invalidate(OBJEDNAVKA_DETAIL_AREA, id));
    }
}

/**
 * Načtení přehledu objednávek - jen několik "důležitých" objednávek zobrazených na hlavní stránce uživatele.
 * @param uzivatelId ID uživatele
 * @returns {Function}
 */
export function fetchObjednavkyPrehledIfNeeded(uzivatelId) {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(OBJEDNAVKY_PREHLED_LIST_AREA, uzivatelId, (parent, filter) => {
            const fulltext = filter.fulltext && filter.fulltext.length > 0 ? filter.fulltext : null;
            const filterReqVO: ObjednavkaFilterReqVO = {
                datumDo: null,
                datumOd: null,
                pobockaIdList: null,
                spolecnostId: null,
                stavList: null,
                stredisko: null,
                uzivatelIdVyrizuje: null,
                uzivatelId: parent,
                findText: fulltext
            }
            return ObjednavkaApi.getObjednavkaTopX(5, filterReqVO);
        }));
    }
}

/**
 * Filtrování přehledu objednávek na základě filtru.
 * @param filter filter
 * @return {function(*, *)}
 */
export function filterObjednavkyPrehled(filter) {
    return (dispatch) => {
        dispatch(list.SimpleListActions.filter(OBJEDNAVKY_PREHLED_LIST_AREA, filter));
    }
}

/**
 * Zneplatnění přehledu objednávek.
 * @returns {Function}
 */
export function invalidateObjednavkyPrehled() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(OBJEDNAVKY_PREHLED_LIST_AREA));
    }
}

/**
 * Načtení oprávnění na objednávku.
 * @returns {Function}
 */
export function fetchObjednavkaRightsIfNeeded(idObjednavka) {
    return (dispatch) => {
        dispatch(detail.DetailActions.fetchIfNeeded(OBJEDNAVKA_RIGHTS_AREA, idObjednavka, (parent) => {
            return ObjednavkaApi.getObjednavkaRights(parent);
        }));
    }
}

/**
 * Zneplatnění oprávnění na objednávku.
 * @returns {Function}
 */
export function invalidateObjednavkaRights(idObjednavka) {
    return (dispatch) => {
        dispatch(detail.DetailActions.invalidate(OBJEDNAVKA_RIGHTS_AREA, idObjednavka));
    }
}

/**
 * Načtení detailu uživatele objednávky.
 * @returns {Function}
 */
export function fetchObjednavkaUzivatelIfNeeded(id) {
    return (dispatch) => {
        dispatch(detail.DetailActions.fetchIfNeeded(OBJEDNAVKA_UZIVATEL_AREA, id, (parent) => {
            return SubjektApi.getUzivatel(parent);
        }));
    }
}

/**
 * Zneplatnění detailu uživatele objednávky.
 * @returns {Function}
 */
export function invalidateObjednavkaUzivatel(id) {
    return (dispatch) => {
        dispatch(detail.DetailActions.invalidate(OBJEDNAVKA_UZIVATEL_AREA, id));
    }
}

/**
 * Načtení detailu společnosti uživatele objednávky.
 * @returns {Function}
 */
export function fetchObjednavkaSpolecnostIfNeeded(id) {
    return (dispatch) => {
        dispatch(detail.DetailActions.fetchIfNeeded(OBJEDNAVKA_SPOLECNOST_AREA, id, (parent) => {
            return SubjektApi.getSpolecnost(parent);
        }));
    }
}

/**
 * Zneplatnění detailu společnosti uživatele objednávky.
 * @returns {Function}
 */
export function invalidateObjednavkaSpolecnost(id) {
    return (dispatch) => {
        dispatch(detail.DetailActions.invalidate(OBJEDNAVKA_SPOLECNOST_AREA, id));
    }
}

/**
 * Načtení adres uživatele objednávky.
 * @param id ID uživatele
 * @returns {Function}
 */
export function fetchObjednavkaUzivatelAdresyIfNeeded(id) {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(OBJEDNAVKA_UZIVATEL_ADRESY_AREA, id, (parent) => {
            return SubjektApi.getAdresyUzivatel(parent, null, false);
        }));
    }
}

/**
 * Zneplatnění adres uživatele objednávky.
 * @returns {Function}
 */
export function invalidateObjednavkaUzivatelAdresy() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(OBJEDNAVKA_UZIVATEL_ADRESY_AREA));
    }
}

/**
 * Načtení adres společnosti objednávky.
 * @param id ID společnosti
 * @returns {Function}
 */
export function fetchObjednavkaSpolecnostAdresyIfNeeded(id) {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(OBJEDNAVKA_SPOLECNOST_ADRESY_AREA, id, (parent) => {
            return SubjektApi.getAdresySpolecnost(parent, false);
        }));
    }
}

/**
 * Zneplatnění adres společnosti objednávky.
 * @returns {Function}
 */
export function invalidateObjednavkaSpolecnostAdresy() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(OBJEDNAVKA_SPOLECNOST_ADRESY_AREA));
    }
}

/**
 * Nastavení karet uživatele objednávky.
 * @param karty seznam karet uživatele
 * @returns {Function}
 */
export function setObjednavkaUzivatelKarty(karty) {
    return (dispatch) => {
        dispatch(list.SimpleListActions.setData(OBJEDNAVKA_UZIVATEL_KARTY_AREA, "", karty));
    }
}

/**
 * Zneplatnění karet uživatele objednávky.
 * @returns {Function}
 */
export function invalidateObjednavkaUzivatelKarty() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(OBJEDNAVKA_UZIVATEL_KARTY_AREA));
    }
}

/**
 * Nastavení nákladových středisek společnosti objednávky.
 * @param spolecnostId ID společnosti
 * @param nakladovaStrediska seznam nákladových středisek
 * @returns {Function}
 */
export function setObjednavkaSpolecnostNakladovaStrediska(spolecnostId, nakladovaStrediska) {
    return (dispatch) => {
        dispatch(list.SimpleListActions.setData(OBJEDNAVKA_SPOLECNOST_NAKLSTRED_AREA, spolecnostId, nakladovaStrediska));
    }
}

/**
 * Zneplatnění nákladových středisek společnosti objednávky.
 * @returns {Function}
 */
export function invalidateObjednavkaSpolecnostNakladovaStrediska() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(OBJEDNAVKA_SPOLECNOST_NAKLSTRED_AREA));
    }
}

/**
 * Nastavení předvoleb společnosti objednávky - režim operátor.
 * @param spolecnostId id společnosti
 * @param predvolby objekt předvoleb
 * @returns {Function}
 */
export function setObjednavkaSpolecnostPredvolby(spolecnostId, predvolby) {
    return (dispatch) => {
        dispatch(detail.DetailActions.setData(OBJEDNAVKA_SPOLECNOST_PREDVOLBY_AREA, spolecnostId, predvolby));
    }
}

/**
 * Zneplatnění předvoleb společnosti objednávky - režim operátor.
 * @returns {Function}
 */
export function invalidateObjednavkaSpolecnostPredvolby(spolecnostId) {
    return (dispatch) => {
        dispatch(detail.DetailActions.invalidate(OBJEDNAVKA_SPOLECNOST_PREDVOLBY_AREA, spolecnostId));
    }
}

/**
 * Načtení poboček uživatele pro objednávku.
 * @param uzivatelId ID uživatele
 * @param spolecnostId ID společnosti
 * @returns {Function}
 */
export function fetchObjednavkaUzivatelPobockyIfNeeded(uzivatelId, spolecnostId) {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(OBJEDNAVKA_UZIVATEL_POBOCKY_AREA, uzivatelId, (parent) => {
            return CiselnikApi.getPobockyVydejSelect(spolecnostId, parent);
        }));
    }
}

/**
 * Zneplatnění poboček uživatele pro objednávku.
 * @returns {Function}
 */
export function invalidateObjednavkaUzivatelPobocky() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(OBJEDNAVKA_UZIVATEL_POBOCKY_AREA));
    }
}

/**
 * Načtení seznamu SMJ souborů.
 * @param forceFetch zda provést nové načtení, implicitně false
 * @returns {Function}
 */
export function fetchObjednavkaSmjIfNeeded(forceFetch = false) {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(OBJEDNAVKA_SEZNAM_SMJ_AREA, null, () => {
            return ObjednavkaApi.vratSeznamSmj();
        }, forceFetch));
    }
}

/**
 * Zneplatnění seznamu SMJ souborů.
 * @returns {Function}
 */
export function invalidateObjednavkaSmj() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(OBJEDNAVKA_SEZNAM_SMJ_AREA));
    }
}

/**
 * Načtení seznamu kódů úkonů, které jsou na objednávce nastaveny.
 *
 * @param objednavkaId ID objednávky
 * @returns {Function}
 */
export function fetchObjednavkaKodUkonyIfNeeded(objednavkaId) {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(OBJEDNAVKA_KOD_UKON_LIST_AREA, objednavkaId, objednavkaId => {
            return ObjednavkaApi.getObjednavkaKodUkonSet(objednavkaId);
        }));
    }
}

/**
 * Zneplatnění seznamu kódů úkonů, které jsou na objednávce nastaveny.
 *
 * @returns {Function}
 */
export function invalidateObjednavkaKodUkony() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(OBJEDNAVKA_KOD_UKON_LIST_AREA));
    }
}


// ===================== Načítání dat rozpracované objednávky z local storage =====================

/**
 * Načtení dat kroku Zakázka.
 * @returns {Function}
 */
export function fetchDataZakazkaIfNeeded(uzivatelId) {
    return (dispatch) => {
        dispatch(detail.DetailActions.fetchIfNeeded(ZAKAZKA_DETAIL_AREA, "", () => {
            return Promise.resolve(localStorageUtils.loadOrderData(uzivatelId, 1));
        }));
    }
}

/**
 * Zneplatnění dat kroku Zakázka.
 * @returns {Function}
 */
export function invalidateDataZakazka() {
    return (dispatch) => {
        dispatch(detail.DetailActions.invalidate(ZAKAZKA_DETAIL_AREA, ""));
    }
}

/**
 * Načtení dat kroku Zákazník.
 * @returns {Function}
 */
export function fetchDataZakaznikIfNeeded(uzivatelId) {
    return (dispatch) => {
        dispatch(detail.DetailActions.fetchIfNeeded(ZAKAZNIK_DETAIL_AREA, "", () => {
            return Promise.resolve(localStorageUtils.loadOrderData(uzivatelId, 2));
        }));
    }
}

/**
 * Zneplatnění dat kroku Zákazník.
 * @returns {Function}
 */
export function invalidateDataZakaznik() {
    return (dispatch) => {
        dispatch(detail.DetailActions.invalidate(ZAKAZNIK_DETAIL_AREA, ""));
    }
}

/**
 * Načtení dat kroku Doprava.
 * @returns {Function}
 */
export function fetchDataDopravaIfNeeded(uzivatelId) {
    return (dispatch) => {
        dispatch(detail.DetailActions.fetchIfNeeded(DOPRAVA_DETAIL_AREA, "", () => {
            return Promise.resolve(localStorageUtils.loadOrderData(uzivatelId, 3));
        }));
    }
}

/**
 * Zneplatnění dat kroku Doprava.
 * @returns {Function}
 */
export function invalidateDataDoprava() {
    return (dispatch) => {
        dispatch(detail.DetailActions.invalidate(DOPRAVA_DETAIL_AREA, ""));
    }
}

/**
 * Načtení dat kroku Platba.
 * @returns {Function}
 */
export function fetchDataPlatbaIfNeeded(uzivatelId) {
    return (dispatch) => {
        dispatch(detail.DetailActions.fetchIfNeeded(PLATBA_DETAIL_AREA, "", () => {
            return Promise.resolve(localStorageUtils.loadOrderData(uzivatelId, 4));
        }));
    }
}

/**
 * Zneplatnění dat kroku Platba.
 * @returns {Function}
 */
export function invalidateDataPlatba() {
    return (dispatch) => {
        dispatch(detail.DetailActions.invalidate(PLATBA_DETAIL_AREA, ""));
    }
}

/**
 * Načtení čísla posledního kroku objednávky pro která máme data.
 * @returns {Function}
 */
export function fetchObjednavkaLastStep(uzivatelId) {
    return (dispatch) => {
        dispatch(detail.DetailActions.fetchIfNeeded(LAST_SAVED_STEP_AREA, uzivatelId, (parent) => {
            return Promise.resolve(localStorageUtils.getLastSavedOrderStep(parent));
        }));
    }
}

/**
 * Zneplatnění čísla posledního kroku objednávky pro která máme data.
 * @returns {Function}
 */
export function invalidateObjednavkaLastStep(uzivatelId) {
    return (dispatch) => {
        dispatch(detail.DetailActions.invalidate(LAST_SAVED_STEP_AREA, uzivatelId));
    }
}

/**
 * Načtení čísla posledního kroku objednávky pro která máme uložená data s příznakem finished = true.
 * @returns {Function}
 */
export function fetchObjednavkaLastFinishedStep(uzivatelId) {
    return (dispatch) => {
        dispatch(detail.DetailActions.fetchIfNeeded(LAST_SAVED_FINISHED_STEP_AREA, uzivatelId, (parent) => {
            return Promise.resolve(localStorageUtils.getLastSavedFinishedOrderStep(parent));
        }));
    }
}

/**
 * Zneplatnění čísla posledního kroku objednávky pro která máme data.
 * @returns {Function}
 */
export function invalidateObjednavkaLastFinishedStep(uzivatelId) {
    return (dispatch) => {
        dispatch(detail.DetailActions.invalidate(LAST_SAVED_FINISHED_STEP_AREA, uzivatelId));
    }
}

/**
 * Načtení času rozpracování objednávky uživatele z local storage.
 * @returns {Function}
 */
export function fetchCasRozpracovaniObjednavky(uzivatelId) {
    return (dispatch) => {
        dispatch(detail.DetailActions.fetchIfNeeded(CAS_ROZPRACOVANI_DETAIL_AREA, uzivatelId, (parent) => {
            return Promise.resolve(localStorageUtils.load(parent, CAS_ROZPRACOVANI_KEY));
        }));
    }
}

/**
 * Zneplatnění času rozpracování objednávky uživatele.
 * @param uzivatelId ID uživatele
 * @returns {Function}
 */
export function invalidateCasRozpracovaniObjednavky(uzivatelId) {
    return (dispatch) => {
        dispatch(detail.DetailActions.invalidate(CAS_ROZPRACOVANI_DETAIL_AREA, uzivatelId));
    }
}

/**
 * Načtení výchozích hodnot uživatele.
 * @param uzivatelId ID uživatele
 * @param spolecnostId ID společnosti
 * @returns {Function}
 */
export function fetchObjednavkaUzivatelVychoziHodnotyIfNeeded(uzivatelId, spolecnostId) {
    return (dispatch) => {
        dispatch(detail.DetailActions.fetchIfNeeded(OBJEDNAVKA_UZIVATEL_VYCHOZI_HODNOTY_AREA, uzivatelId + spolecnostId, () => {
            return SubjektApi.getUzivatelVychoziHodnoty(uzivatelId, spolecnostId);
        }));
    }
}

/**
 * Zneplatnění výchozích hodnot uživatele.
 * @param uzivatelId ID uživatele
 * @param spolecnostId ID společnosti
 * @returns {Function}
 */
export function invalidateObjednavkaUzivatelVychoziHodnoty(uzivatelId, spolecnostId) {
    return (dispatch) => {
        dispatch(detail.DetailActions.invalidate(OBJEDNAVKA_UZIVATEL_VYCHOZI_HODNOTY_AREA, uzivatelId + spolecnostId));
    }
}

/**
 * Provede odstranění všech dat souvisejících s rozpracovanou objednávkou a zneplatnění příslušných area.
 * @param uzivatelId ID uživatele
 */
export function clearRozpracovanaObjednavka(uzivatelId) {
    return (dispatch) => {
        localStorageUtils.clearAllOrderData(uzivatelId);
        dispatch(invalidateDataZakazka());
        dispatch(invalidateDataZakaznik());
        dispatch(invalidateDataDoprava());
        dispatch(invalidateDataPlatba());
        dispatch(invalidateObjednavkaLastFinishedStep(uzivatelId));
        dispatch(invalidateObjednavkaLastStep(uzivatelId));
        dispatch(invalidateCasRozpracovaniObjednavky(uzivatelId));
    }
}

/**
 * Zobrazí toastr pro každou notifikaci ve výsledku akce.
 *
 * @param akceResult VO s výsledkem operace s objednávkou
 */
export function notifyIfNeeded(akceResult) {
    if (akceResult.notifikaceVOList && akceResult.notifikaceVOList.length > 0) {
        akceResult.notifikaceVOList.forEach(notifikace => {
            switch (notifikace.vyznam) {
                case EnumVyznam.INFO:
                    toastr.info(notifikace.zprava);
                    break;
                case EnumVyznam.WARN:
                    toastr.warning(notifikace.zprava);
                    break;
                case EnumVyznam.ERROR:
                    toastr.error(notifikace.zprava);
                    break;
            }
        });
    }
}
